<template>
  <div>
    <template v-if="!game">
      <h3>Такой игры нет</h3>
      К сожалению данной игры не существует. Возможно вы ошиблись ссылкой или она была удалена
    </template>
    <template v-else>
      <h3>Игра {{game.name}} <template v-if="gameActive">, Раунд {{currentRound+1}}</template></h3>
      <el-row>
        <el-col :span="8">{{gameActive?'Активная':'Неактивная'}} </el-col>
        <el-col :span="16">
          <el-switch
            v-model="activated"
            @change="changeActiveStatus"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">Ссылка на регистрацию на игру для команд </el-col>
        <el-col :span="12"><el-input :value="gamelink" ref="gamelink"/></el-col>
        <el-col :offset="1" :span="3">
          <el-button @click="copyToBuffer" type="primary" plain>Копировать</el-button>
        </el-col>
      </el-row>
      <template v-if="gameActive && !gameOver">
        <el-row>
          <el-col :span="8">Раунд</el-col>
          <el-col :span="16">
            <template v-if="!roundActive">
              Пауза перед раундом
            </template>
            {{currentRound + 1}}
          </el-col>
        </el-row>
        <el-row v-if="roundActive">
          <el-col :span="8" >
            <el-button v-if="!countDownDeadline" @click="startCountdown" type="primary">Запустить обратный отсчет</el-button>
            <el-button v-else @click="stopCountdown" type="danger">({{countDownText}}) Остановить обратный отсчет</el-button>
          </el-col>
          <el-col :span="8"><el-button @click="finishRound" type="warning">Окончить раунд</el-button></el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="8">
            <el-button @click="startRound" type="success">Стартовать этот раунд</el-button>
          </el-col>
          <el-col :span="8">
            <el-button type="info">
              <a :href="`/admin/game/${game.id}/checkAnswers`" target="_blank">Открыть проверку ответов</a>
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template v-else-if="gameActive && gameOver">
        <el-row>
          <el-col :span="8">Игра окончена</el-col>
          <el-col :span="16">
            <el-button type="info">
              <a :href="`/admin/game/${game.id}/checkAnswers`" target="_blank">Открыть проверку ответов</a>
            </el-button>
          </el-col>
        </el-row>
      </template>
      <div>
        <hr />
        <h3>Команды</h3>
        <template v-if="teams.length > 0">
          <el-row>
            <el-col :span="8">Название</el-col>
            <el-col :span="4">Очки всего</el-col>
            <el-col :span="4">Очки за прошлый раунд</el-col>
            <el-col :span="4">Ответы за этот раунд</el-col>
          </el-row>
          <el-row v-for="team in teams" :key="team.id">
            <el-col :span="8">{{team.name}}</el-col>
            <el-col :span="4">{{getTeamPoints(team.id)}}</el-col>
            <el-col :span="4">{{getTeamPointsForPreviousRound(team.id)}}</el-col>
            <el-col :span="4">{{timeOfTeamAnswersForRound(team.id)}}</el-col>
          </el-row>
        </template>
        <template v-else>
          На эту игру еще нет зарегистрированных команд
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AdminGame',
  data() {
    return {
      activated: true,
      countDownDeadline: null,
      countDownTimer: null,
      countDownText: null
    }
  },
  props: ['id'],
  computed:{
    game() {
      return this.$store.getters.game(this.id);
    },
    gameActive() {
      return this.game && (this.game.id == this.$store.getters.currentGame.gameid);
    },
    gameOver() {
      return  this.currentRound >= this.game.rounds?.length;
    },
    teams() {
      const teamsIdsMap = this.game.teams ? {...this.game.teams} : {};
      return this.$store.state.teams.filter(team => !!teamsIdsMap[team.id]) || [];
    },
    gamelink() {
      return `${window.location.protocol}//${window.location.host}/game/${this.id}`;
    },
    currentGame() {
      return this.$store.state.currentGame;
    },
    currentRound() {
      return this.currentGame.round || 0;
    },
    roundActive() {
      return this.currentGame.round_active;
    }

  },
  methods: {
    changeActiveStatus(activate) {
      this.activated = !activate;
      if(!activate) {
        this.$confirm('Вы собираетесь дезактивировать игру, вы уверены', 'Внимание', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('activateGame', {gameid: this.id, activate: false})
              .then(() => {
                this.$message({type: 'success', message: 'Игра дезактивирована'});
                this.activated = false;
              })
              .catch(err => this.$message({type: 'error', message: err.message}));
          }).catch(() => {
            this.$message({type: 'info', message: 'Дезактивация отмнена'});          
          });
      } else {
        this.$confirm('Вы собираетесь активировать игру, вы уверены', 'Внимание', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('activateGame', {gameid: this.id, activate: true})
              .then(() => {
                this.$message({type: 'success', message: 'Игра активирована'});
                this.activated = true;
              })
              .catch(err => this.$message({type: 'error', message: err.message}));
          }).catch(() => {
            this.$message({type: 'info', message: 'Активация отмнена'});          
          });
      }
    },
    startRound() {
      this.$confirm('Вы собираетесь запустить раунд, уверены?', 'Внимание')
      .then(() => {
        this.$store.dispatch('startRound')
          .then(() => this.$message({type: 'success', message: 'Раунд запущен'}))
          .catch(({message}) => this.$message({type: 'error', message}));
      }).catch(() => {
        this.$message({type: 'info', message: 'Запуск отмнен'});          
      });
    },
    finishRound() {
      this.$confirm('Вы собираетесь завершить раунд, уверены?', 'Внимание')
      .then(() => {
        this.$store.dispatch('nextRound')
          .then(() => this.$message({type: 'success', message: 'Раунд завершен'}))
          .catch(({message}) => this.$message({type: 'error', message}));
      }).catch(() => {
        this.$message({type: 'info', message: 'Завершение отмнено'});          
      });
    },
    startCountdown() {
      this.$confirm('Вы собираетесь запустить обратный отсчет, уверены?', 'Внимание')
      .then(() => {
        this.$store.dispatch('startCountdown')
          .then(() => {
            this.$message({type: 'success', message: 'Обратный отсчет запущен'})
          })
          .catch(({message}) => this.$message({type: 'error', message}));
      }).catch(() => {
        this.$message({type: 'info', message: 'Запуск обратного отсчета отмнен'});          
      });
    },
    stopCountdown() {
      this.$confirm('Вы собираетесь отменить обратный отсчет, уверены?', 'Внимание')
      .then(() => {
        this.$store.dispatch('stopCountdown')
          .then(() => {
            this.countDownDeadline = null;
            clearInterval(this.countDownTimer);
            this.countDownTimer = null;
            this.$message({type: 'success', message: 'Обратный отсчет сброшен'})
          })
          .catch(({message}) => this.$message({type: 'error', message}));
      }).catch(() => {
        this.$message({type: 'info', message: 'Сброс обратного отсчета отмнен'});
      });
    },
    countDownTick() {
      const leftSeconds =  Math.floor(this.countDownDeadline - Date.now() / 1000);
      if(leftSeconds <= 0) {
        clearInterval(this.countDownTimer);
        this.$store.dispatch('nextRound');
        this.countDownTimer = null;
        this.countDownDeadline = null;
      } else {
        this.countDownText = `${leftSeconds} сек`;
      }
    },
    timeOfTeamAnswersForRound(team_id) {
      const ts = this.$store.state.gameAnswers.find(ans => ans.team_id == team_id && ans.round == this.currentRound)?.ts;
      if(ts) {
        return new Date(ts).toLocaleString();
        //const d = new Date(ts);        
        //return `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
      }
      return null
    },
    getTeamPoints(team_id) {
      if(this.game.scores) {
        if(Array.isArray(this.game.scores[team_id])) {
          return this.game.scores[team_id].reduce((acc, cur) => acc+cur,0);
        } else if (this.game.scores[team_id] instanceof Object) {
          return Object.values(this.game.scores[team_id]).reduce((acc, cur) => acc+cur,0);
        }
      }
      return 0;
    },
    getTeamPointsForPreviousRound(team_id) {
      if (this.game.scores && (Array.isArray(this.game.scores[team_id]) ||
        this.game.scores[team_id] instanceof Object)) {
        return this.game.scores[team_id][this.currentRound - 1] || 0;
      }
      return 0;
    },
    copyToBuffer() {
      try {
        this.$refs.gamelink.select();
        document.execCommand('copy');
        this.$message({type:'success', message: 'Скопирвано в буффер обмена'});
      } catch(ex) {
        console.log('exception while copying to clipboard', ex.message);
      }
      
    }
  },
  watch: {
    gameActive: {
      handler(newVal) {
        this.activated = newVal;
      },
      immediate: true
    },
    currentGame: {
      handler(newCurGameVal) {
        if(this.countDownDeadline != newCurGameVal.deadline) {
          this.countDownDeadline = newCurGameVal.deadline;
          if(this.countDownDeadline != null) {
            if(this.countDownTimer == null) {
              this.countDownTimer = setInterval(() => this.countDownTick(), 1000);
            }
          } else {
            if(this.countDownTimer != null) {
              clearInterval(this.countDownTimer);
              this.countDownTimer = null;
              this.countDownText = null;
            }
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$store.dispatch('initGameAnswers', this.id);
  }
}
</script>

<style>

</style>